import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibRecatSummaryIconComponent } from './lib-recat-summary-icon.component';

@NgModule({
  declarations: [LibRecatSummaryIconComponent],
  imports: [CommonModule],
  exports: [LibRecatSummaryIconComponent],
})
export class LibRecatSummaryIconModule {}
